import { useDispatch } from "react-redux";
import {
  openModal,
  closeModal,
  setModalTitle,
  setModalSize,
  setModalContent,
} from "./Modal.slice";

export const useModal = () => {
  const dispatch = useDispatch();

  const open = (options = {}) => {
    dispatch(openModal(options));
  };

  const close = () => {
    dispatch(closeModal());
  };

  const setTitle = (title) => {
    dispatch(setModalTitle(title));
  };

  const setSize = (sizeOptions) => {
    dispatch(setModalSize(sizeOptions));
  };

  const setContent = (contentOptions) => {
    dispatch(setModalContent(contentOptions));
  };

  return {
    open,
    close,
    setTitle,
    setSize,
    setContent,
  };
};
